var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.26087,
    y: 0.26087,
    width: 23.4783,
    height: 15.4783,
    rx: 1.73913,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.26087,
    y: 0.26087,
    width: 23.4783,
    height: 15.4783,
    rx: 1.73913,
    stroke: "#EAECF0",
    strokeWidth: 0.521739
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3399 10.8657H5.78216L4.61404 6.4692C4.5586 6.26696 4.44088 6.08817 4.26771 6.00391C3.83555 5.79214 3.35934 5.62361 2.83984 5.53861V5.36935H5.34924C5.69558 5.36935 5.95533 5.62361 5.99862 5.91891L6.6047 9.09024L8.16169 5.36935H9.67614L7.3399 10.8657ZM10.5419 10.8657H9.07077L10.2822 5.36935H11.7533L10.5419 10.8657ZM13.6565 6.89197C13.6998 6.59594 13.9596 6.42667 14.2626 6.42667C14.7388 6.38417 15.2576 6.46917 15.6905 6.6802L15.9502 5.49682C15.5173 5.32755 15.0411 5.24255 14.6089 5.24255C13.1811 5.24255 12.1421 6.00388 12.1421 7.0605C12.1421 7.86432 12.878 8.28639 13.3975 8.54065C13.9596 8.79418 14.176 8.96344 14.1327 9.21698C14.1327 9.59727 13.6998 9.76654 13.2677 9.76654C12.7482 9.76654 12.2287 9.63977 11.7532 9.42801L11.4935 10.6121C12.013 10.8232 12.575 10.9082 13.0945 10.9082C14.6955 10.9499 15.6905 10.1893 15.6905 9.04771C15.6905 7.61006 13.6565 7.52579 13.6565 6.89197V6.89197ZM20.8401 10.8657L19.6719 5.36935H18.4172C18.1575 5.36935 17.8977 5.53861 17.8112 5.79214L15.6481 10.8657H17.1625L17.4648 10.0626H19.3256L19.4988 10.8657H20.8401ZM18.6329 6.8494L19.065 8.92088H17.8536L18.6329 6.8494Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.b96345c206f435a63c06a664759b7dbd.svg";
export { ForwardRef as ReactComponent };